import { useSearchParams } from "utils/customHooks"

export const FREE_PARAM_NAME = "free"
export const FREE_PARAM_VALUE = "1"

export function useOnlyFreeSessions() {
    const searchParams = useSearchParams()
    return searchParams.get(FREE_PARAM_NAME) === FREE_PARAM_VALUE
}
